import { render, staticRenderFns } from "./setActor.vue?vue&type=template&id=4cf65ff2&scoped=true&"
import script from "./setActor.vue?vue&type=script&lang=js&"
export * from "./setActor.vue?vue&type=script&lang=js&"
import style0 from "./setActor.vue?vue&type=style&index=0&id=4cf65ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf65ff2",
  null
  
)

export default component.exports